import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/retryWhen';
import 'rxjs/add/operator/takeWhile';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/delay';
import { ReservationStayPreferencesDataValidator } from './validators/data.validators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LogService } from '../services/logging.service';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { DefaultRetryHandler } from './handlers/retry.handlers';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '../config';
import { GenericDao } from './generic.dao';
import { resolveLocale } from '../../common/common';

const CLASS_NAME = 'ReservationStayPreferencesDao';
const LANGUAGE_HEADER_NAME = 'accept-language';
const MOBILE_CHANNEL = 'WEBMW';
@Injectable()
export class ReservationStayPreferencesDao extends GenericDao {
  constructor(http: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, log: LogService) {
    super(CLASS_NAME, http, appConfig, appConfig.reservationStayPreferencesDAO, new DefaultRetryHandler(), new ReservationStayPreferencesDataValidator(), log);
  }
  protected buildHeaders(customHeaders?: { [key: string]: string }): HttpHeaders {
    let headers: HttpHeaders = super.buildHeaders(customHeaders);
    headers = headers.set(LANGUAGE_HEADER_NAME, resolveLocale(this.appConfig));
    return headers;
  }
  get(reservationNumber: string, date: string, hotelCode: string, mobileChannel: boolean = false): Observable<any> {
    const url = this.daoConfig.url
      .replace('{reservationNumber}', reservationNumber)
      .replace('{date}', date);
    return super.doGet(url, { hotelMnemonic: hotelCode }, {channel: mobileChannel ? MOBILE_CHANNEL : ''}, true);
  }

  put(reservationNumber: string, date: string, hotelCode: string, stayPreferences: object, mobileChannel: boolean = false): Observable<any> {
    const url = this.daoConfig.url
      .replace('{reservationNumber}', reservationNumber)
      .replace('{date}', date);
    return super.doPut(url, stayPreferences, {channel: mobileChannel ? MOBILE_CHANNEL : ''}, { hotelMnemonic: hotelCode });
  }

}




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/reservation-stay-preferences.dao.ts